import toast, { ToastOptions } from 'react-hot-toast';

type CustomToastOptions = {
  message: any;
  intent?: 'success' | 'warning' | 'danger' | 'primary';
  icon?: string;
};

export const toaster = {
  show: ({ message, intent = 'primary', icon }: CustomToastOptions) => {
    const opts: ToastOptions = {
      icon,
      style: {
        borderRadius: '8px',
        padding: '12px 16px',
        background: '#fff',
        color: '#333',
      },
    };

    switch (intent) {
      case 'success':
        toast.success(message, opts);
        break;
      case 'warning':
        toast(message, { ...opts, icon: icon || '⚠️' });
        break;
      case 'danger':
        toast.error(message, opts);
        break;
      case 'primary':
      default:
        toast(message, opts);
        break;
    }
  },
};